import type { SearchResultDocumentKey } from 'Types/globalSearch/searchResults.types'

/**
 * Maps search result field keys to their i18n translation IDs for display in
 * the autocomplete inline highlight (e.g. "First name: <match>").
 *
 * Any field NOT listed here falls back to an auto-generated label derived from
 * the field name (e.g. `case_item.order_number` → "Order Number"). This fallback
 * is English-only and will NOT be translated in de/fr or other locales.
 *
 * Add an entry here for every field that needs proper translations.
 */
export const GS_AUTOCOMPLETE_DIRECT_FIELDS: Partial<
  Record<SearchResultDocumentKey, string>
> = {
  // case items
  'case_item.employee_email': 'Email',
  'case_item.employee_first_name': 'First_name',
  'case_item.employee_full_name': 'Name',
  'case_item.employee_last_name': 'Last_name',
  'case_item.tags.name': 'typesenseAttribute_case_item_tags_name',

  // employees
  'employee.cost_center_name': 'Cost_center',
  'employee.email': 'Email',
  'employee.first_name': 'First_name',
  'employee.full_name': 'Name',
  'employee.last_name': 'Last_name',
  'employee.phone_number': 'Phone_number',
  'employee.tags.name': 'typesenseAttribute_employee_tags_name',

  // rentals
  'rental.employee.email': 'Email',
  'rental.employee.first_name': 'First_name',
  'rental.employee.last_name': 'Last_name',
  'rental.employee.phone_number': 'Phone_number',
  'rental.stocklist_item.imei': 'IMEI',
  'rental.stocklist_item.imei2': 'IMEI2',
  'rental.stocklist_item.serial_number': 'Serial_number',

  // return cases
  'return_case.employee.email': 'Email',
  'return_case.employee.first_name': 'First_name',
  'return_case.employee.last_name': 'Last_name',
  'return_case.employee.phone_number': 'Phone_number',
  'return_case.stocklist_item.imei': 'IMEI',
  'return_case.stocklist_item.serial': 'Serial_number',
  'return_case.tracking_number': 'Tracking_reference',
}
